import React, { FC, useEffect, useMemo, useState } from 'react';
import { MenuItem } from '@mui/material';
import Loader from 'react-spinners/BarLoader';
import { toast } from 'react-toastify';
import API from 'api/API';
import { Organisation } from 'api/Endpoints/UserManagementEndpoint';
import DropDown from 'components/DropDown/DropDown';
import { MAX_KELSEN_TENANT_NAME } from 'hooks/useTenant';
import { Role, userRolesIndex } from 'store/user/auth0.helpers';
import { useUser } from 'store/user/useUser';
import { isInMaxKelsenOrg } from 'utils/helpers/permissions.helpers';

interface TenantDropDownProps {
  changeTenant: (tenant: string) => void;
  selectedTenant: string;
}

const TenantDropDown: FC<TenantDropDownProps> = ({ changeTenant, selectedTenant }) => {
  const handleSelectTenant = (tenant: string): void => {
    changeTenant(tenant);
  };

  const [tenantsListIsLoading, setTenantsListIsLoading] = useState(false);
  const user = useUser();

  const [tenants, setTenants] = useState<Organisation[]>();

  const isMkSuperUser = useMemo(
    () => user.isAuthenticated && user[userRolesIndex].includes(Role.MkSystemAdmin) && isInMaxKelsenOrg(user),
    [user],
  );

  const getTenants = async () => {
    setTenantsListIsLoading(true);
    try {
      const tenantsList = await API.userManagement.listTenants();
      setTenants(tenantsList);
    } catch (e) {
      toast.error('could not get tenants');
    }
    setTenantsListIsLoading(false);
  };

  useEffect(() => {
    isMkSuperUser && getTenants();
  }, [isMkSuperUser]);

  return (
    <DropDown
      style={{ marginRight: '20px', marginTop: '5px', marginBottom: '5px' }}
      onChange={event => handleSelectTenant(event.target.value as string)}
      defaultValue={MAX_KELSEN_TENANT_NAME}
      value={selectedTenant || MAX_KELSEN_TENANT_NAME}
    >
      {tenantsListIsLoading ? (
        <Loader />
      ) : (
        tenants?.map(tenant => (
          <MenuItem value={tenant.name} key={tenant.name}>
            {tenant.name}
          </MenuItem>
        ))
      )}
    </DropDown>
  );
};

export default TenantDropDown;
